export default "__VITE_ASSET__9d1b0678__"